import { Permissions } from '../../utils/permissions';

// Generates a table displaying all webhook templates associated with an auto group
class GroupWebhooks extends HTMLElement{
  constructor() {
    super();
  }
  async connectedCallback() {
    this.group_id = document.getElementById('object_id').value;

    this.isAdmin = await Permissions.hasPermissionForGroup(
      Permissions.ALL.admin_is_admin,
      this.group_id
    );

    this.innerHTML = `<div>
                        <div class="row">
                          <div class="col-sm-12">
                            <h3>Manage Integration Templates</h3>
                          </div>  
                        </div>
                      </div>
                      
                      <table id="group_webhooks" class="table" style="width:100%">
                          <tfoot style="display: table-header-group;">
                            <tr>
                                ${this.isAdmin ? '<th></th>' : ''}
                                <th></th>
                                <th></th>
                                <th></th>
                                <th></th>
                            </tr>
                          </tfoot>
                          <thead>
                              <tr>
                                ${this.isAdmin ? '<th>Template ID</th>' : ''}
                                <th>Name</th>
                                <th>Template Type</th>
                                <th>View Template</th>
                                <th>In Use</th>
                              </tr>
                          </thead>
                      </table>

                      <webhook-desc-modal></webhook-desc-modal>`;
    this.init();
  }

  init() {
    this.table = $('#group_webhooks').DataTable({
      "ajax": `/admin/groups/${this.group_id}/action_templates`,
      "columns": [
        ...(this.isAdmin ? [{ data: 'action_template_id' }] : []),
        { "data": "name" },
        { 
          "data": "template_type",
          "class": "text-center"
        },
        {
          "render": function(data, type, row) {
            return `<a class="desc-link">&nbspView</a>`;
          },
          "class": "text-center"

        },
        {
          data: "action_template",
          "render": function ( data, type, row ) {
            return ( type === 'display') ? '<span class="fa '+((data.is_used==true) ? "fa-check":"fa-times")+'"></span>' : data
          }, // feature
          "class": "text-center"
        }
      ],
      initComplete: function () {
        var column = this.api().column(1);
        var select = $('<select><option value="">All Types</option></select>')
            .prependTo( $(column.footer()).empty() )
            .on( 'change', function () {
                var val = $.fn.dataTable.util.escapeRegex(
                    $(this).val()
                );

                column
                    .search( val ? '^'+val+'$' : '', true, false )
                    .draw();
            } );

        column.data().unique().sort().each( function ( d, j ) {
            select.append( '<option value="'+d+'">'+d+'</option>' )
        } );            
      },
      "order": [[1, 'asc']]
    });

    // Opens a modal with the template description of the target row
    $('#group_webhooks tbody').on('click', 'tr td a.desc-link', async function (e) {
      e.preventDefault();
      let row = this.table.row(e.target.closest('tr')).data();
      console.log(row)
      this.querySelector("webhook-desc-modal").showTemplate(row.template, row.template_type);
      $("#webhookDescModal").modal("show");
    }.bind(this));
  }
}

customElements.define("group-webhooks", GroupWebhooks)